/**
 * @fileoverview POST handler for the "/inbox_vision/:app_group_id/create_email_test" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { inboxVisionAppGroupIdCreateEmailTestCacheKeys } from "./constants";
import type { PostInboxVisionAppGroupIdCreateEmailTestProps, InboxVisionCreateEmailTestResult } from "./types";

export const postInboxVisionAppGroupIdCreateEmailTest = reactQueryMutationAdapter(
  inboxVisionAppGroupIdCreateEmailTestCacheKeys,
  ({
    appGroupId,
    message,
    previewIds,
  }: PostInboxVisionAppGroupIdCreateEmailTestProps): Promise<InboxVisionCreateEmailTestResult> => {
    return fetch(`/inbox_vision/${appGroupId}/create_email_test`, "POST", { message, preview_ids: previewIds });
  }
);
